.skeleton {
  position: relative;
  flex: 0 0 auto;
  width: 100%;
  height: 100%;
  border-radius: 0.625rem;
  overflow: hidden;
  background: var(--neutral-100);

  &:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: '';
    background-image: linear-gradient(
      -45deg,
      rgba(var(--neutral-100-rgb), 0) 0%,
      rgba(var(--neutral-100-rgb), 0) 40%,
      rgba(var(--neutral-rgb), 0.575) 50%,
      rgba(var(--neutral-100-rgb), 0) 60%,
      rgba(var(--neutral-100-rgb), 0) 100%
    );
    background-repeat: no-repeat;
    background-position: 150% 0;
    background-size: 200% 100%;
    animation: skeletonShine 1s infinite;
  }

  &.clear {
    background: rgba(var(--neutral-rgb), 0.07);

    &:before {
      background-image: linear-gradient(
        -45deg,
        rgba(var(--neutral-rgb), 0) 0%,
        rgba(var(--neutral-rgb), 0) 35%,
        rgba(var(--neutral-rgb), 0.15) 50%,
        rgba(var(--neutral-rgb), 0) 65%,
        rgba(var(--neutral-rgb), 0) 100%
      );
    }
  }

  &.round {
    border-radius: 99rem;
  }

  &.rounded {
    border-radius: 1rem;
  }
}

@keyframes skeletonShine {
  0% {
    background-position: 165% 0;
  }
  100% {
    background-position: -70% 0;
  }
}
